<template>
  <div>
    <div class="border-0" v-if="Object.keys(entities_filtered).length > 0">
      <b-card no-body class="border-0">
        <b-tabs card small active-nav-item-class="active-entity">
          <b-tab :title="entity.label" lazy class="p-0" v-for="entity in entities_filtered" :key="entity.id">
            <b-card-text>
              <generic-data-widget :platform-id="platformId" :entity-id="entity.id"></generic-data-widget>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-else>
      <b-alert show variant="info" class="mt-3 ml-3 mr-3">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> No data available or public data view is restricted.
      </b-alert>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import GenericDataWidget from '@/components/widgets/generic/GenericDataWidget'
// import { scrollTab, tabItem } from 'vue-scrollable-tabs'

export default {
  name: 'GenericEntitiesWidget',
  components: {
    GenericDataWidget
    // scrollTab,
    // tabItem
  },
  props: [
    'platformId'
  ],
  mounted () {
  },
  computed: {
    ...mapGetters(['entities', 'parameters']),
    entities_filtered: function () {
      const entities = this.entities(this.platformId)
      const filteredEntities = {}
      for (const entityId in entities) {
        if (Object.prototype.hasOwnProperty.call(entities, entityId)) {
          const entity = entities[entityId]
          if (Number(entity.restricted) === 0 || 'restricted' in this.$route.query) {
            filteredEntities[entityId] = entity
          }
        }
      }
      return filteredEntities
    }
  }
}
</script>

<style>

.active-entity {
  font-weight: bold;
}

</style>
